export default "__VITE_ASSET__BoJtGwuf__"